module.exports = __webpack_public_path__ + "img/yacht-5.3da91f12.jpg";